import { mapState } from 'vuex';
import {
  BadgeDTO,
  EntrancePlantDetailDTO,
  GateGuestDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import plantsClient from '@/core/services/plants';
import { Options, Vue } from 'vue-class-component';
import BadgeItem from '../../../EntrancePlantBadges/BadgeItem/BadgeItem.vue';
import AddBadgePage from '../../../EntrancePlantBadges/DialogAddBadge/AddBadgePage/AddBadgePage.vue';
import DialogAddBadge from '../../../EntrancePlantBadges/DialogAddBadge/DialogAddBadge.vue';

@Options({
  name: 'BadgeTab',
  props: {
    editingGuest: {
      type: Object as PropType<GateGuestDTO>,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  watch: {
    'editingGuest.badgeCode': function () {
      this.guestWasEdited();
    },
  },
  components: {
    BadgeItem,
    AddBadgePage,
    DialogAddBadge,
  },
  emits: ['badge-edited', 'error-badge'],
})
export default class BadgeTab extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  editingGuest!: GateGuestDTO;
  isEdit!: boolean;

  noModification = new GateGuestDTO();
  badge: BadgeDTO | null = null;
  isVisibleAddBadgeGuest = false;

  plantBadges: BadgeDTO[] = [];
  badgesList: BadgeDTO[] = [];

  disabled!: boolean;
  async fetchBadges() {
    this.plantBadges = await plantsClient.badgeAll(
      this.currentEntrancePlant.desktopId as number
    );
  }

  async mounted() {
    await this.fetchBadges();
    if (this.editingGuest.badgeCode) {
      this.badge = new BadgeDTO({
        badgeCode: this.editingGuest.badgeCode,
      });
    }
    this.noModification = new GateGuestDTO({ ...this.editingGuest });
  }

  get noBadgeText() {
    const textToSplit = this.$t('AppResourceEP.BadgesListEmptyMessage');
    const noBadgeTextLines = textToSplit.split('\n');
    return noBadgeTextLines;
  }

  get addButtonDisabled() {
    return this.editingGuest.badgeCode;
  }

  addBadge(addedBadge: BadgeDTO) {
    this.badgesList.push(addedBadge);
    this.editingGuest.badgeCode = addedBadge.badgeCode;
    this.badge = new BadgeDTO({ badgeCode: addedBadge.badgeCode });
  }

  removeBadge(badgeToRemove: BadgeDTO) {
    this.editingGuest.badgeCode = undefined;
    this.badgesList = this.badgesList.filter(
      (badge) => badge !== badgeToRemove
    );
  }

  async handleAddBadgeGuest() {
    this.isVisibleAddBadgeGuest = !this.isVisibleAddBadgeGuest;
  }

  guestWasEdited() {
    this.$emit('error-badge', false);
    this.$emit('badge-edited', this.badgeEdited());
  }

  badgeEdited() {
    const badgeEdit =
      this.editingGuest.badgeCode !== this.noModification.badgeCode;
    return badgeEdit;
  }

  handleDeleteBadge() {
    this.badge = null;
    this.editingGuest.badgeCode = undefined;
  }
}
